import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import AttributeRatings from './attributeRattings';

const useStyles = makeStyles(() => ({
  root: {
    display: 'grid',
    gap: 56,
    width: '100%',
  },
}));

const EmployeeCycleAttributeRatings = ({
  translations,
  attributes = [],
  visibleRatings,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {attributes.map(attribute => (
        <AttributeRatings
          key={`attribute_${attribute.id}`}
          translations={translations}
          attribute={attribute}
          visibleRatings={visibleRatings}
        />
      ))}
    </div>
  );
};

EmployeeCycleAttributeRatings.propTypes = {
  translations: PropTypes.object.isRequired,
  attributes: PropTypes.arrayOf(PropTypes.object),
  visibleRatings: PropTypes.object.isRequired,
};

export default EmployeeCycleAttributeRatings;
